import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ApiUrl from '../../utils/config';
import { FormPage, Field } from '../../common/components/FormKit';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      await axios.post(`${ApiUrl}/api/Auth/forgot-password`, { email });
      setMessage('Если аккаунт с таким email существует, на него отправлен новый пароль. Проверьте почту (и папку «Спам»).');
      setEmail('');
    } catch (err: unknown) {
      const msg = axios.isAxiosError(err) && err.response?.data?.message
        ? err.response.data.message
        : 'Произошла ошибка. Попробуйте позже.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormPage
      title="Восстановление пароля"
      subtitle="Мы отправим на почту временный пароль для входа"
      variant="narrow"
    >
      <form className="form-page__form" onSubmit={handleSubmit}>
        <p className="form-page__lead">
          Укажите email вашего аккаунта. После входа с временным паролем вам будет предложено заменить его на свой.
        </p>

        {error && <div className="form-page__alert" role="alert">{error}</div>}
        {message && <div className="form-page__notice" role="status">{message}</div>}

        <div className="form-page__row form-page__row--single">
          <Field label="Email" htmlFor="forgot-email">
            <input
              id="forgot-email"
              className="form-page__input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              placeholder="name@example.com"
              disabled={loading}
              required
            />
          </Field>
        </div>

        <div className="form-page__actions">
          <Link to="/login" className="form-page__login-link"><span>Вернуться к входу</span></Link>
          <button type="submit" className="btn form-page__submit" disabled={loading}>
            {loading ? 'Отправка…' : 'Отправить пароль'}
          </button>
        </div>
      </form>
    </FormPage>
  );
};

export default ForgotPassword;
